// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3Pudv","signatureBlock":"Footer_signatureBlock__2O6Vy","signature":"Footer_signature__SiTUc"};